// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4695":"674c1afc","8124":"1ab73c39"}[chunkId] + ".chunk.css";
};